var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.content)?_c('div',{staticClass:"sem-conteudo"},[_c('p',[_vm._v("\n    Não foi encontrado nenhuma informação. Por favor altere os seus filtros de busca!\n  ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }